@if (!loading) {
  @if (dTypeSendForm?.dType?.column) {
    <div class="w-full flex flex-col p-6">
      <ng-container *transloco="let t">
        @if (!message.to) {
          <mat-form-field class="fuse-mat-no-subscript w-full mt-4">
            <mat-icon matPrefix class="icon-size-5 mr-4" [svgIcon]="'heroicons_solid:search'"></mat-icon>
            <input [formControl]="getControl('to')" [placeholder]="t('searchMissionUsers')" matInput
              type="text" required [matAutocomplete]="ac" [matTooltip]="t('searchMissionUsers')">
              <mat-autocomplete #ac="matAutocomplete" [displayWith]="displayFn">
                @if (getControl('to').value === null || getControl('to').value === '') {
                  <mat-option disabled>
                    {{ 'startSearching' | transloco }}
                  </mat-option>
                }
                @if ((users | async)?.length === 0 && getControl('to').value !== '' ) {
                  <mat-option disabled>
                    {{ 'missionUsersNotFound' | transloco }}
                  </mat-option>
                }
                @for (option of users | async; track option) {
                  <mat-option [value]="option">
                    {{ option.displayName }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-hint class="mt-1 ml-6">{{ 'startSearching' | transloco }}</mat-hint>
            @if (getControl('to').errors && getControl('to').touched) {
              @if (getControl('to').errors.required) {
                <mat-error>
                  {{ 'errorRequiredField' | transloco }}
                </mat-error>
              }
              @if (invalidUser) {
                <mat-error>
                  {{ 'errorInvalidUsers' | transloco }}
                </mat-error>
              }
            }
          }
          @for (column of dTypeSendForm.dType?.column; track column) {
            @if (dTypeSendForm.fields[column.name]; as field) {
              @if (message[column.name] === undefined) {
                <dtype-item class="w-full mt-4"
                [field]="field"></dtype-item>
              }
            }
          }
          <!-- <ng-container>
          <mat-label class="mt-4 font-medium">{{ t('priority') }}</mat-label>
          <mat-button-toggle-group *ngIf="!message.priority" [formControl]="getControl('priority')">
            <mat-button-toggle value="high">{{ t('priorityHigh') }}</mat-button-toggle>
            <mat-button-toggle value="normal">{{ t('priorityNormal') }}</mat-button-toggle>
            <mat-button-toggle value="low">{{ t('priorityLow') }}</mat-button-toggle>
          </mat-button-toggle-group>
        </ng-container> -->
        <div class="flex flex-row justify-end my-4">
          <button mat-raised-button class="mr-8" color="primary" (click)="sendPush()">
            {{ 'sendPush' | transloco }}
          </button>
        </div>
      </ng-container>
    </div>
  }
} @else {
  <mat-spinner class="my-4"></mat-spinner>
}

